
import { RefreshCw, AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface EmailFolderErrorProps {
  folderName: string;
  onRefresh?: () => void;
}

const EmailFolderError = ({ folderName, onRefresh }: EmailFolderErrorProps) => {
  const folderLabels: Record<string, string> = {
    inbox: 'Inbox',
    sent: 'Sent Items',
    drafts: 'Drafts',
    trash: 'Trash'
  };

  return (
    <div className="flex flex-col h-full">
      <div className="border-b p-4 flex items-center justify-between bg-card">
        <div className="flex items-center gap-2">
          <h1 className="font-semibold text-xl">{folderLabels[folderName] || folderName}</h1>
        </div>
      </div>
      
      <div className="flex-1 p-6 flex flex-col items-center justify-center">
        <Card className="max-w-md w-full">
          <CardContent className="pt-6 text-center">
            <AlertCircle className="h-12 w-12 text-destructive mx-auto mb-4" />
            <h2 className="text-xl font-semibold mb-2">Database Error</h2>
            <p className="text-muted-foreground mb-4">
              There was an error connecting to the email database. This is likely due to a WebAssembly loading issue.
            </p>
            <p className="text-sm text-muted-foreground mb-4">
              Try refreshing the page or check if your browser supports WebAssembly.
            </p>
            <Button variant="outline" onClick={onRefresh || (() => window.location.reload())}>
              <RefreshCw className="mr-2 h-4 w-4" />
              Refresh
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default EmailFolderError;
